import { denormalize } from 'normalizr';
import {
  TILE,
  TILES_GROUP,
  TILES_TYPE,
  tileSchema,
  tilesGroupSchema,
  tilesTypeSchema
} from './schema';

export default {
  GET_TILES_TYPES: state => {
    return denormalize(
      state[`${TILES_TYPE}Ids`],
      [tilesTypeSchema],
      state.entities
    );
  },

  GET_TILES_GROUPS: state => {
    return denormalize(
      state[`${TILES_GROUP}Ids`],
      [tilesGroupSchema],
      state.entities
    );
  },

  GET_TILES_GROUP_BY_ID: state => tilesGroupId => {
    return denormalize(Number(tilesGroupId), tilesGroupSchema, state.entities);
  },

  GET_DEFAULT_TILES_GROUP: state => {
    if (state.defaultTilesGroupId) {
      return state.entities[TILES_GROUP][state.defaultTilesGroupId];
    }

    return Object.values(state.entities[TILES_GROUP]).find(item =>
      Boolean(item.default)
    );
  },

  GET_TILES: state => {
    return denormalize(state[`${TILE}Ids`], [tileSchema], state.entities);
  },

  GET_TILE_BY_ID: state => tileId => {
    return denormalize(Number(tileId), tileSchema, state.entities);
  },

  GET_TILES_BY_GROUP_ID: (state, getters) => tilesGroupId => {
    const group = getters.GET_TILES_GROUP_BY_ID(tilesGroupId);

    return group ? group.tiles : [];
  }
};
